import React, { useEffect, useRef, useState } from 'react';
import { env } from '../config/env';

const TurnstileCaptcha = ({ onVerify }: { onVerify: (token: string) => void }) => {
  const turnstileRef = useRef<HTMLDivElement | null>(null);
  const widgetIdRef = useRef<string | null>(null);
  const [key, setKey] = useState(0);

  useEffect(() => {
    const destroyExistingWidget = () => {
      if (widgetIdRef.current && (window as any).turnstile && !turnstileRef.current?.hasChildNodes()) {
        (window as any).turnstile.remove(widgetIdRef.current);
        widgetIdRef.current = null;
      }
    };

    const renderWidget = () => {
      if ((window as any).turnstile && turnstileRef.current) {
        if (!turnstileRef.current.hasChildNodes()) {
          try {
            widgetIdRef.current = (window as any).turnstile.render(turnstileRef.current, {
              sitekey: env.TURNSTILE_SITE_KEY,
              callback: (newToken: string) => {
                onVerify(newToken);
              },
              'refresh-expired': 'auto'
            });
          } catch (error) {
            setTimeout(() => setKey(prev => prev + 1), 1000);
          }
        }
      }
    };

    const initializeTurnstile = () => {
      if ((window as any).turnstile) {
        renderWidget();
      } else {
        const existingScript = document.querySelector(
          `script[src="${env.TURNSTILE_URL}/turnstile/v0/api.js"]`
        );

        if (!existingScript) {
          const script = document.createElement('script');
          script.src = `${env.TURNSTILE_URL}/turnstile/v0/api.js`;
          script.async = true;
          script.onload = renderWidget;
          document.body.appendChild(script);
        } else {
          // Se o script já existe, tentar renderizar após um pequeno delay
          setTimeout(renderWidget, 100);
        }
      }
    };

    // Inicializar
    initializeTurnstile();

    // Cleanup
    return () => {
      destroyExistingWidget();
    };
  }, [onVerify, key]);

  return (
    <div 
      style={{marginBottom:'10px', marginTop:'-10px', textAlign:'center', alignItems:'center'}}
      ref={turnstileRef}
      key={key}
    />
  );
};

export default TurnstileCaptcha;
